import { styled } from '@mui/material/styles';
import FormGroup from '@mui/material/FormGroup';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';

import COLORS from '../../styles/theme/colors';

export const Item = styled('div')({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  borderBottom: ' 0.4px solid #D5D5D5',
  padding: '0 33px 10px',

  '&:last-child': {
    borderBottom: 'none'
  }
});

export const ItemTitle = styled('h4')({
  color: COLORS.textSecondColor,
  margin: '10px 0 0',
  fontWeight: '500',
  fontSize: 16
});

export const Content = styled(FormGroup)({
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'row',
  width: '100%',
  flexWrap: 'wrap',

  '& .MuiFormControlLabel-root': {
    flex: 1,
    minWidth: '45%',
    color: COLORS.textColor,
    fontWeight: 400,
    fontSize: 16
  }
});

export const FormWrap = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  padding: '20px',
  background: COLORS.accentLight,
  borderRadius: 14,
  marginBottom: 15,
  position: 'relative',
  border: '2px solid transparent',

  '&.non-saved': {
    border: `0.7px dashed ${COLORS.orange}`
  }
});

export const Row = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  gap: '30px',
  alignItems: 'center'
});

export const FormItem = styled('div')({
  maxWidth: '50%',
  flex: 1,
  alignItems: 'center',
  marginBottom: 10,

  '& p, & .MuiFormControlLabel-root .MuiFormControlLabel-label': {
    color: '#7B8898'
  },

  '& .MuiInputLabel-root': {
    marginBottom: 4
  },

  '& .MuiTextField-root': {
    width: '100%',
    background: 'white',

    '& input': {
      padding: '7px 14px',
      background: 'white'
    }
  }
});
export const FiledContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '15px'
});

export const Field = styled('div')({
  '& .MuiTextField-root': {
    width: '130px',
    background: 'white',

    '& input': {
      padding: '7px 14px',
      background: 'white'
    }
  }
});
export const AccordionDetailsWrap = styled(AccordionDetails)({
  display: 'flex',
  flexDirection: 'column',

  '& .addButton': {
    marginLeft: 'auto',
    fontWeight: 500,
    fontSize: 16,
    transition: '.3s all ease'
  },

  '& > .MuiAccordionDetails-root': {
    borderBottom: '1px solid red'
  }
});

export const AccordionWrap = styled(Accordion)({
  boxShadow: 'none',
  minHeight: 'auto',
  margin: '0 14px',
  display: 'flex',
  padding: '0',
  flexDirection: 'column',

  '& .MuiAccordionSummary-root': {
    minHeight: 'auto',
    margin: '0 14px'
  },

  '&.Mui-expanded, &.active': {
    minHeight: 'auto',
    margin: '0 14px 15px',
    borderBottom: '1px solid #ededed',

    '& .MuiAccordionSummary-root': {
      minHeight: 'auto',
      margin: '0 14px'
    }
  },

  '&:before': {
    display: 'none'
  }
});

export const AccordionTitle = styled(AccordionSummary)({
  '& .title': {
    '& span': {
      color: '#7B8898'
    }
  },

  '& .MuiAccordionSummary-content': {
    width: '100%',
    padding: '10px 0',
    margin: 0,
    minHeight: 'auto',

    '&.Mui-expanded': {
      minHeight: 'auto',
      margin: '0',
      padding: '10px 0',
    }
  }
});

export const Actions = styled('div')({
  display: 'flex',
  position: 'absolute',
  right: 5,
  top: 1,
  color: COLORS.red
});
